import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/f_logo_RGB-Blue_58.png'


const _hoisted_1 = { class: "scroll_wrapper" }
const _hoisted_2 = { class: "main_part" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "gallery_link" }, "In Anikas Kunstwelt eintreten", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fb_link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/anika.wagner.art",
    target: "_blank",
    rel: "noopener noreferrer",
    title: "Anikas Kunstwelt auf FB"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Facebook-Seite Aniksa Kunstwelt"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/galerie",
        class: "gallery_link_button"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ]))
}